import { render } from "./ProfileModalShell.vue?vue&type=template&id=6cc69d6c&scoped=true"
import script from "./ProfileModalShell.vue?vue&type=script&lang=js"
export * from "./ProfileModalShell.vue?vue&type=script&lang=js"

import "./ProfileModalShell.vue?vue&type=style&index=0&id=6cc69d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc69d6c"]])

export default __exports__